import React, { Component } from "react";
import { Link } from "react-router-dom";

class VideoV4 extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="qm-hero ltn__primary-bg">
        <img
          className="qm-hero__bg"
          src={publicUrl + "assets/img/hero-tower-bridge.jpg"}
          alt="Living room of a managed residence overlooking Tower Bridge and the Thames"
          fetchpriority="high"
        />

        {/* Two passes: darkest in the bottom-left where the copy sits, and a lighter
            wash across the top for the transparent navbar. The middle-right is left
            alone so the bridge itself stays clear. */}
        <div className="qm-hero__scrim" />

        <div className="qm-hero__inner">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">
                <p className="qm-hero__eyebrow">Block &amp; Estate Management</p>
                <h1 className="qm-hero__title">Quoin Management</h1>
                <p className="qm-hero__tagline">Your Property, Our Priority.</p>
                <Link to="/contact" className="qm-hero__cta">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>

        <style>{`
          .qm-hero {
            position: relative;
            width: 100%;
            height: 100vh;
            min-height: 600px;
            max-height: 900px;
            overflow: hidden;
          }

          .qm-hero__bg {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            /* Biased left so the bridge survives the crop on narrow viewports. */
            object-position: 38% center;
          }

          .qm-hero__scrim {
            position: absolute;
            inset: 0;
            background:
              linear-gradient(to right,
                rgba(0, 0, 0, 0.72) 0%,
                rgba(0, 0, 0, 0.45) 32%,
                rgba(0, 0, 0, 0.05) 65%,
                rgba(0, 0, 0, 0) 100%),
              linear-gradient(to bottom,
                rgba(0, 0, 0, 0.45) 0%,
                rgba(0, 0, 0, 0.05) 25%,
                rgba(0, 0, 0, 0.10) 55%,
                rgba(0, 0, 0, 0.65) 100%);
          }

          .qm-hero__inner {
            position: relative;
            z-index: 2;
            display: flex;
            align-items: flex-end;
            height: 100%;
            padding-bottom: 9vh;
          }

          .qm-hero__eyebrow {
            display: flex;
            align-items: center;
            gap: 14px;
            margin-bottom: 18px;
            color: #fff;
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 2.5px;
            text-transform: uppercase;
          }
          .qm-hero__eyebrow::before {
            content: "";
            width: 46px;
            height: 2px;
            background: var(--ltn__secondary-color);
          }

          .qm-hero__title {
            margin-bottom: 14px;
            color: #fff;
            font-size: clamp(40px, 6vw, 82px);
            font-weight: 700;
            line-height: 1.05;
            text-shadow: 0 2px 24px rgba(0, 0, 0, 0.35);
          }

          .qm-hero__tagline {
            margin-bottom: 34px;
            color: rgba(255, 255, 255, 0.88);
            font-size: clamp(17px, 1.7vw, 22px);
            font-weight: 400;
            line-height: 1.5;
          }

          .qm-hero__cta {
            display: inline-block;
            padding: 16px 44px;
            background: var(--ltn__secondary-color);
            border-radius: 4px;
            color: #fff;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 0.5px;
            text-transform: uppercase;
            transition: transform 0.25s ease, box-shadow 0.25s ease;
          }
          .qm-hero__cta:hover,
          .qm-hero__cta:focus {
            color: #fff;
            transform: translateY(-2px);
            box-shadow: 0 10px 24px rgba(123, 2, 0, 0.45);
          }

          /* Staggered entrance */
          .qm-hero__eyebrow,
          .qm-hero__title,
          .qm-hero__tagline,
          .qm-hero__cta {
            opacity: 0;
            animation: qmHeroUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
          }
          .qm-hero__eyebrow { animation-delay: 0.15s; }
          .qm-hero__title   { animation-delay: 0.28s; }
          .qm-hero__tagline { animation-delay: 0.41s; }
          .qm-hero__cta     { animation-delay: 0.54s; }

          @keyframes qmHeroUp {
            from { opacity: 0; transform: translateY(24px); }
            to   { opacity: 1; transform: none; }
          }

          @media (prefers-reduced-motion: reduce) {
            .qm-hero__eyebrow,
            .qm-hero__title,
            .qm-hero__tagline,
            .qm-hero__cta {
              opacity: 1;
              animation: none;
            }
            .qm-hero__cta:hover { transform: none; }
          }

          @media (max-width: 767px) {
            .qm-hero {
              height: auto;
              min-height: 560px;
              max-height: none;
            }
            .qm-hero__inner {
              min-height: 560px;
              padding-top: 140px;
              padding-bottom: 64px;
            }
            .qm-hero__cta {
              padding: 14px 34px;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default VideoV4;
